const getCssVar = (name, fallback) => {
  if (typeof document === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
};

const buildDefaultStyles = () => {
  const PRIMARY = getCssVar('--color-primary-500', '#0BA5EC');
  const PRIMARY_HOVER = getCssVar('--color-primary-600', '#0086C9');
  const PRIMARY_ACTIVE = getCssVar('--color-primary-700', '#026AA2');

  return {
    disableDefaultStyles: true,
    css: {
      html: { height: '100%' },
      body: {
        margin: '0',
        width: '100%',
        height: '100%',
        display: 'flex',
        'align-items': 'center'
      },
      form: { display: 'flex', 'align-items': 'center', width: '100%', height: '100%' },
      input: {
        'line-height': 'normal',
        'box-sizing': 'border-box',
        border: 'none',
        width: '100%',
        height: 'auto',
        padding: '0 8px',
        'border-radius': '8px',
        'background-color': '#FFF',
        color: 'rgb(99, 99, 99)',
        'text-align': 'left',
        'font-size': '16px'
      },
      ':focus-visible': { outline: 'none' },
      '::placeholder': { color: 'rgb(158, 158, 158)' },
      "input[type='text']": { 'min-height': '40px' },
      button: {
        'background-color': PRIMARY,
        color: '#FFF',
        border: '1px solid #FFFFFF',
        'border-radius': '4px',
        'font-weight': '500',
        'font-size': '14px',
        width: 'fit-content',
        'text-align': 'center',
        'min-height': '40px',
        'padding-left': '12px',
        'padding-right': '12px',
        'padding-top': '0px',
        'padding-bottom': '0px',
        cursor: 'pointer',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center'
      },
      'button:hover': { 'background-color': PRIMARY_HOVER },
      'button:active': { 'background-color': PRIMARY_ACTIVE },
      'button:disabled': {
        'background-color': '#E0F2FE',
        cursor: 'not-allowed'
      },
      'button:focus': {
        outline: '0',
        'box-shadow': '0 0 0 2px rgba(203, 240, 253, 1)'
      },
      div: {
        width: 'unset',
        margin: '0',
        height: '100%',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        'margin-left': '8px'
      },
      label: {
        'font-family': 'Arial',
        'font-size': '14px',
        'line-height': '20px',
        color: '#374145'
      },
      'input[type="radio"]': {
        width: '20px',
        height: '20px',
        margin: '0 8px 0 0',
        border: '1px solid #D5D7DA',
        'border-radius': '50%',
        'background-color': 'transparent',
        appearance: 'none',
        cursor: 'pointer',
        'box-sizing': 'border-box',
        padding: '0',
        'box-shadow': 'none'
      },
      'input[type="radio"]:checked': {
        border: `1px solid ${PRIMARY}`,
        'background-color': PRIMARY,
        'box-shadow': 'inset 0 0 0 5px #FFFFFF'
      },
      'input[type="radio"]:hover': {
        border: `1px solid ${PRIMARY_HOVER}`,
        'box-shadow': 'inset 0 0 0 5px #FFFFFF'
      },
      'input[type="radio"]:hover:checked': {
        border: `1px solid ${PRIMARY_HOVER}`,
        'background-color': PRIMARY_HOVER,
        'box-shadow': 'inset 0 0 0 5px #FFFFFF'
      },
      'input[type="radio"]:focus': { outline: '2px solid #CBF0FD' },
      'input[type="radio"]:disabled': {
        border: '1px solid #F5F5F5',
        cursor: 'not-allowed'
      },
      'input[type="radio"]:disabled:checked': {
        border: '1px solid #E0F2FE',
        'background-color': '#E0F2FE',
        'box-shadow': 'inset 0 0 0 5px #FFFFFF'
      },
      'input[type="radio"] + label': {
        'padding-left': '0',
        'line-height': '20px',
        color: '#252B37',
        cursor: 'pointer',
        'font-size': '14px',
        margin: '0'
      },
      '.loading-svg': {
        display: 'none',
        color: '#fff'
      },
      '.button-text': { display: 'inline-block' },
      '.loading .loading-svg': { display: 'inline-block' },
      '.loading .button-text': { display: 'none' },
      '.spin': { animation: 'spin 1s linear infinite' },
      '@keyframes spin': {
        to: { transform: 'rotate(1turn)' }
      }
    }
  };
};

export const getCardStyles = ({ isFullWidthButton = false } = {}) => {
  const defaultStyles = buildDefaultStyles();
  return {
    ...defaultStyles,
    css: {
      ...defaultStyles.css,
      form: { ...defaultStyles.css.form, 'justify-content': 'flex-end' },
      input: { ...defaultStyles.css.input },
      ...(isFullWidthButton && {
        button: {
          ...defaultStyles.css.button,
          width: '100%',
          'min-height': '48px',
          'font-size': '16px',
          'font-weight': '600'
        }
      })
    }
  };
};

export const getAchStyles = () => {
  const defaultStyles = buildDefaultStyles();
  return {
    ...defaultStyles,
    css: {
      ...defaultStyles.css,
      form: {
        ...defaultStyles.css.form,
        'flex-direction': 'row',
        'flex-wrap': 'nowrap',
        'align-items': 'center',
        height: '100%'
      },
      body: { ...defaultStyles.css.body, height: '100%' },
      input: {
        ...defaultStyles.css.input,
        width: '100%'
      },
      div: {
        ...defaultStyles.css.div,
        'justify-content': 'flex-start',
        'align-items': 'center',
        'margin-left': '0',
        'margin-bottom': '0',
        'margin-right': '32px'
      },
      'div:last-of-type': {
        'margin-right': '0'
      },
      'input[type="radio"] + label': {
        ...defaultStyles.css['input[type="radio"] + label'],
        'margin-right': '0'
      },
      button: {
        ...defaultStyles.css.button,
        'margin-left': 'auto'
      }
    }
  };
};
